<template>
  <a-spin :spinning="isSpinning" size="large">
    <div>
      <h6 class="heading-small text-muted mb-4">
        Brand {{ brandName }}
      </h6>
  
      <base-alert v-if="errors.length" type="danger">
        <b>You have the following error(s):</b>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </base-alert>
  
      <b-tabs
        v-show="profileId != 0 && this.$attrs.viewMode"
        content-class="mt-3"
      >
        <b-tab title="Details" active v-on:click="openDetails"></b-tab>
        <b-tab title="History" v-on:click="openHistory">
          <b><label>Created By: </label></b>
          {{ brand.created_by || "System"  }} | {{ brand.created_at | dateFilter }}
          <br />
          <b><label>Updated By:</label></b>
          {{ brand.updated_by || "System"  }} | {{ brand.updated_at | dateFilter }}
        </b-tab>
      </b-tabs>
  
      <form id="form-proper">
        <!-- {{brand}} -->
        <div class="col-md-12">
          <base-input label="Channel Type">
          <a-select showSearch v-model="inputChannelType" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All" allowClear>
              <a-select-option v-for="val in channelTypeOptions" :key="val.id" :value="val.id">{{val.name}}</a-select-option>
          </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Site Name">
          <a-select showSearch v-model="inputSites" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All" allowClear>
              <a-select-option v-for="val in siteOptions" :key="val.id" :value="val.id">{{val.name}}</a-select-option>
          </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Site Concept Name">
          <a-select showSearch v-model="inputSiteConcept" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All" allowClear>
              <a-select-option v-for="val in siteConceptOptions" :key="val.id" :value="val.id">{{val.name}}</a-select-option>
          </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Store Owner">
          <a-select showSearch v-model="inputStoreOwner" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All" allowClear>
              <a-select-option v-for="val in storeOwnerOptions" :key="val.id" :value="val.id">{{val.name}}</a-select-option>
          </a-select>
          </base-input>
        </div>

        <div class="col-md-12" style="text-align: right;">
          <button type="button" class="btn btn-primary btn-sm" @click.prevent="searchSiteBrand">
            Search
          </button>
        </div>
        <hr>
        <div>
          <base-input v-if="brandData && brandData.length > 0 ">
            <a-tree
              checkable
              :key="componentKey"
              :checkedKeys="selectedRowKeys"
              :treeData="brandData"
              @check="onCheckSiteId"
              :disabled="this.$attrs.viewMode"
              defaultExpandAll
            />
          </base-input>
          <template v-else >
            <span>No Results found.</span>
          </template>
        </div>
  
        <div>
            <button v-show="!this.$attrs.viewMode"
              type="button"
              class="btn btn-primary float-right"
              @click.prevent="update"
            >
              Save
            </button>
        </div>
      </form>
    </div>
  </a-spin>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import ValidateField from "../../components/validateFormUtils.js";
import secureStorage from '../../controllers/secureStorage.js'
import DynamicForm from "../DynamicForm.vue";
import { mapState } from "vuex";
import Autocomplete from 'vuejs-auto-complete'

import moment from "moment";
var component_x;
let brandData = [];


export default {
  components: {
    DynamicForm,Autocomplete
  },
  computed: {
    ...mapState(["endPoint", "profileId", "serverType"]),
  },
  mounted: async function() {
    this.isSpinning = true;

    var brand_data = await HTTPRequest.getRequest(
        this.endPoint + "brands/" + this.profileId,
        null
    );

    if (brand_data == undefined) {
      this.$router.go();
    } else {
      this.brandName = brand_data["name"]
    }


    const sytemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Brand?field_name=name",
      null
    );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        sytemModuleId +
        "?field_name=system_module_id",
      null
    );
    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      if (accSystemModule != null) {
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }
        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
    }
    if (this.$attrs.viewMode == true) {
      var form = document.getElementById("form-proper");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].readOnly = true;
      }
    }
    component_x = this;
    // component_x.selectedRowKeys = [];
    if (component_x.profileId > 0) {
      await this.setSiteBrandTree();
      await this.setSelectedKeys();
    }
    console.log(this.$attrs.viewMode)
    var channel_type = await HTTPRequest.getRequest(
          this.endPoint + "/site_types/get_valid_site_types?is_channel=true",
          null,
          null
      );
    // brands.unshift({code: null, id: null, name: '' })
    this.channelTypeOptions = channel_type;

    var sites = await HTTPRequest.getRequest(
          this.endPoint + "/sites/get_valid_sites?mode=all",
          null,
          null
    );

    this.siteOptions = sites

    var site_concept = await HTTPRequest.getRequest(
          this.endPoint + "/site_concepts/get_valid_site_concepts",
          null,
          null
    );

    this.siteConceptOptions = site_concept

    var companies = await HTTPRequest.getRequest(
          this.endPoint + "/companies/get_valid_companies?mode=all",
          null,
          null
      );
      // brands.unshift({code: null, id: null, name: '' })
    this.storeOwnerOptions = companies;

    this.componentKey++;
    this.isSpinning = false;
  },
  data: function() {
    return {
      brandData,
      brandName:"",
      authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
      inputName: "",
      inputCode: "",
      inputRemark: "",
      errors: [],
      showDetails: true,

      customFormMode: 1,
      customForm: {},
      profileData: {},
      componentKey: 0,
      brand: {},
      formErrors: [],
      brandCategory: null,
      brandOwner: null,
      recordOwner: null,
      selectedRowKeys: [],
      selectedRowNewKeys: [],
      isSpinning: false,
      inputChannelType: [],
      inputSiteConcept: [],
      inputSites: [],
      inputStoreOwner: [],
      channelTypeOptions:[],
      siteOptions: [],
      siteConceptOptions: [],
      storeOwnerOptions:[],
    };

  },
  filters: {
    dateFilter: function(timestamp) {
      return moment(timestamp).format("L LTS");
    },
  },
  methods: {
    formattedDisplay(result) {
                return result.name + ' [' + result.code + ']'
    },
    brandCategoriesEndpoint(input) {
                return this.endPoint + '/brand_categories?name=' + input
    },
    companiesEndpoint(input){
      return this.endPoint + '/companies?name=' + input
    },
    getBrandCategory(group) {
        this.brandCategory = group.display
        this.brand.brand_category_id = group.value
    },
    getBrandOwner(group) {
        this.brandOwner = group.display
        this.brand.brand_owner_id = group.value
    },
    getRecordOwner(group) {
        this.recordOwner = group.display
        this.brand.record_owner_id = group.value
    },

    onCheckSiteId(selectedRowKeys, e) {
      // console.log(selectedRowKeys)
      if(e.checked == true){
        this.selectedRowKeys.push(e.node.eventKey);
        let uids = e.node.$children.map(obj => obj.eventKey).filter(uid => uid !== null && uid !== undefined);
        // console.log(uids)
        if(uids && uids != []){
          // console.log("meron ba dito")
          this.selectedRowKeys.push(...uids)
        }
        // console.log(this.selectedRowKeys)
        // this.combinedArray();
      }else{
        let elementToRemove = e.node.eventKey;
        let uids = e.node.$children.map(obj => obj.eventKey).filter(uid => uid !== null && uid !== undefined);

        // Concatenate elementToRemove and uids into a single array
        let elementsToRemove = [elementToRemove, ...uids];
        // console.log(elementsToRemove)
        // console.log(this.selectedRowKeys)

        let removeKey = this.selectedRowKeys.filter(element => {
            // Check if the element is not included in elementsToRemove
            if (!elementsToRemove.includes(element)) {
                // If the element is not a string, keep it
                if (typeof element !== 'string') {
                    return true;
                }
            }
            // If the element is a string or is included in elementsToRemove, filter it out
            return false;
        });

        // console.log(removeKey)
        this.selectedRowKeys = removeKey
      }
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.bagger;
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors;
      if (this.customFormMode == 3) {
        this.errors = errors;
      }
      this.bagger = mergedHash;
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    openDetails() {
      this.showDetails = true;
    },
    openHistory() {
      this.showDetails = false;
    },

    async searchSiteBrand(){
      this.isSpinning = true;
      let payload = {};
      if(this.inputChannelType != null && this.inputChannelType != "" && this.inputChannelType != []){
        payload["channel_type_id"] = this.inputChannelType;
      }
      if(this.inputSiteConcept != null && this.inputSiteConcept != "" && this.inputSiteConcept != []){
        payload["site_concept_id"] = this.inputSiteConcept;
      }
      if(this.inputSites != null && this.inputSites != "" && this.inputSites != []){
          payload["site_id"] = this.inputSites;
        }
      if(this.inputStoreOwner != null && this.inputStoreOwner != "" && this.inputStoreOwner != []){
        payload["store_owner_id"] = this.inputStoreOwner;
      }
      await this.setSiteBrandTree(payload);

      this.componentKey++

      this.isSpinning = false
    },
    async setSelectedKeys(){
      var site_brand_data = await HTTPRequest.getRequest(
        component_x.endPoint + "brands/get_valid_site_brand_assortments?id=" + component_x.profileId,
        null
      );

      component_x.selectedRowKeys = site_brand_data;

    },
    async setSiteBrandTree(payload){
      var component_x = this
      component_x.brandData = [];
      component_x.brandData.children = [];

      // route to get site_id

      var apiData = await HTTPRequest.getRequest(
        component_x.endPoint + "sites/get_valid_tree_sites?no_ho_site=true&by='site_types'",
        payload
      );

      let treeSites = await function (data, root) {
      var r = [], o = {};
      data.forEach(function (a) {
        if (o[a.key] && o[a.key].children) {
            a.children = o[a.key] && o[a.key].children;
        }
        o[a.key] = a;
        if (a.parent_id === root) {
          r.push(a);
        } else {
            o[a.parent_id] = o[a.parent_id] || {};
            o[a.parent_id].children = o[a.parent_id].children || [];
            o[a.parent_id].children.push(a);
        }
      });
        return r;
      }(apiData, null);

      treeSites.forEach((el) => {
        component_x.brandData.push({
          id: el.id,
          key: el.key,
          title: el.title,
          children: el.children
        });
      });

      let RemoveKeyandRenametoID = (object, deleteKey) => {
        if (object["key"] !== null && typeof object["key"] === 'string') {
          if (!object["key"].includes("ST")) {
            object["key"] = parseInt(object["key"], 10);
          }
        }

        delete object["id"];

        Object.values(object).forEach((val) => {
          if (typeof val === 'object' && val !== null) {
            RemoveKeyandRenametoID(val, deleteKey);
          }
        });
      };

      RemoveKeyandRenametoID(component_x.brandData, 'key');

      // sort so that unspecified first
      this.brandData.sort((a, b) =>
        a.title < b.title ? -1 : Number(a.title > b.title)
      );
    },
    update: async function() {
      
        var brandPayload = { site_id: this.selectedRowKeys };

        var put_request = await HTTPRequest.putRequest(
          this.endPoint + "brands/update_site_brands?id=" + this.profileId,
          null,
          brandPayload
        );
        if (put_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (put_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = put_request["error"].split(",");
          }
        
      }
    },
  },
};
</script>

<style></style>
